
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { ReactComponent as Op36LocationPinIcon } from '../../assets/images/common/icons/op36-location-pin-icon.svg'
import SubmitButton from '../common/buttons/SubmitButton'

import classes from './NoNearbyCommunities.module.scss'
import RequestLocationModal from './RequestLocationModal'

const NoNearbyCommunities = ({ address }) => {
  const { t } = useTranslation()
  const [showRequestLocationModal, setShowRequestLocationModal] = useState(false)

  return (
    <div className={classNames(classes.noNearbyCommunities, 'd-flex flex-column align-items-center h-100')}>
      <Op36LocationPinIcon className={classes.op36LocationPinIcon} />

      <h4 className={classNames(classes.title, 'mt-4')}>{t('communityMap.noNearbyCommunities.title')}</h4>

      <small className={classNames(classes.subtitle, 'mt-2 mb-4')}>
        {t('communityMap.noNearbyCommunities.subtitle')}
      </small>

      <SubmitButton
        onClick={(e) => { e.preventDefault(); setShowRequestLocationModal(true) }}
        buttonMessage={t('communityMap.noNearbyCommunities.requestLocation')}
        buttonColor='orange-button'
        className='mt-auto'
      />

      <RequestLocationModal isOpen={showRequestLocationModal} onClose={() => setShowRequestLocationModal(false)} address={address} />
    </div>
  )
}


NoNearbyCommunities.propTypes = {
  address: PropTypes.string,
}

export default NoNearbyCommunities
